module.exports = __webpack_public_path__ + "media/images/bottles/bottle-rose-2ea648fea4c73cfd46635d8105dc60fd.png";